import random from "./randomNum";

export default function randomAngle(next, afterNext, direction, startingAngle) {
  if (afterNext === undefined) {
    return 90;
  }

  switch (direction) {
    case "sameRow":
      if (+next) {
        // 120 - 150 same pin
        if (+afterNext) {
          return random(90, 120);
        } else {
          return random(150, 210);
        }
      } else {
        // 30 - 60 same pin
        if (+afterNext) {
          return random(60, 90);
        } else {
          return 180 - random(150, 210);
        }
      }
    case "nextRow":
      if (+next) {
        if (+afterNext) {
          return random(60, 89);
        } else {
          if (startingAngle > 75) {
            return random(91, 100);
          } else {
            return random(101, 120);
          }
        }
      } else {
        if (+afterNext) {
          if (startingAngle < 105) {
            return random(89, 80);
          } else {
            return random(79, 60);
          }
        } else {
          return 180 - random(60, 89);
        }
      }

    default:
      break;
  }
}
